import { render } from "./TemperatureControlTable.vue?vue&type=template&id=6f3c88aa&ts=true"
import script from "./TemperatureControlTable.vue?vue&type=script&lang=ts"
export * from "./TemperatureControlTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__